export default __webpack_public_path__ + "static/media/facebook.3f1190f2.svg";